// extracted by mini-css-extract-plugin
var _1 = "RentalPortalApplicantProfileWidgetAttention-moduleaction__ed3vs";
var _2 = "RentalPortalApplicantProfileWidgetAttention-modulecontent__a3Rqb WidgetContentContainer-moduleWidgetContentContainer__HxIkI";
var _3 = "RentalPortalApplicantProfileWidgetAttention-moduletext__nKSA6";
export { _1 as "action", _2 as "content", _3 as "text" }
